<div class="container">
  <!--<h1 class="heading">HOSPITAL COUNT REPORT</h1>-->
  <div class="row">
    <!--      <mat-form-field appearance="outline" class="col-md-4">-->
    <!--        <mat-label>Select Centre</mat-label>-->
    <!--        <mat-select #selectElement  [(ngModel)]="selectedCentreCode">-->
    <!--          <mat-option value ='All'> All Centres</mat-option>-->
    <!--          <mat-option *ngFor=" let c of (centres$|async)  "-->
    <!--                      [value]="c.centreCode">{{c.centreName}} </mat-option>-->
    <!--          &lt;!&ndash;      <mat-option  value="All">All Centres</mat-option>&ndash;&gt;-->
    <!--        </mat-select>-->
    <!--      </mat-form-field>-->

    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input  [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="onEndDateChanged()">
      </mat-date-range-input>
      <mat-hint>dd/MM/yyyy – dd/MM/yyyy</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>


    </mat-form-field>&nbsp; &nbsp;

<!--    <mat-form-field appearance="outline" class="col-md-4">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select #selectElement  [(ngModel)]="selectedCentreCode">-->
<!--        <mat-option value ='All'> All Centres</mat-option>-->
<!--        <mat-option *ngFor=" let c of (centres$|async)  "-->
<!--                    [value]="c.centreCode">{{c.centreName}} </mat-option>-->
<!--        &lt;!&ndash;      <mat-option  value="All">All Centres</mat-option>&ndash;&gt;-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <app-searchable-select class="col-md-4"
                           [(ngModel)]="selectedCentreCode"
                           [options]="centres$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>

    <div class="col-md-2">
      <button mat-mini-fab (click)="search()" [disabled]="isButtonDisabled"><mat-icon>search</mat-icon></button>
      <button  class="mx-2" mat-mini-fab color="accent" (click)="clearAll()"><mat-icon>clear</mat-icon></button>

    </div>


  </div>
  <div class="card p-2">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Hospital Count Report</h2>
        </li>
        <!--          <li class="dropdown m-l-20">-->
        <!--            <label for="search-input"><i class="material-icons search-icon">search</i></label>-->
        <!--            <input placeholder="Search" type="text" class="browser-default search-field"-->
        <!--                   (keyup)='applyFilter($event)' aria-label="Search box" #input>-->
        <!--          </li>-->
      </ul>
      <ul class="header-buttons mr-2">
        <!--      <li>-->
        <!--        <button   mat-mini-fab color="primary" (click)="openAddCarLog()">-->
        <!--          <mat-icon class="col-white" >add</mat-icon>-->
        <!--        </button>-->
        <!--      </li>-->
        <li>
          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Hospital Count Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt="" />
          </div>
        </li>
      </ul>
    </div>

    <mat-progress-bar *ngIf="isLoading" mode="indeterminate">Please wait Data is loading... </mat-progress-bar>
    <table class="table table-striped table-bordered" id="excel-table">
      <thead>
      <tr>
        <th scope="col"><strong>Hospital</strong></th>
        <th scope="col" *ngFor="let c of uniqueCentres"><strong>{{ c }}</strong></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of tableData; let rowIndex = index"
          [ngStyle]="rowIndex === tableData.length - 1 ? { 'background-color': '#ffeb3b', 'color': '#000', 'font-weight': 'bold' } : null">
        <td>
          <strong *ngIf="rowIndex === tableData.length - 1">{{ data.hospital }}</strong>
          <span *ngIf="rowIndex !== tableData.length - 1"><strong>{{ data.hospital }}</strong></span>
        </td>
        <td *ngFor="let centre of data.centres; let i = index"
            [ngStyle]="i === data.centres.length - 1 ? { 'background-color': '#ffeb3b', 'color': '#000', 'font-weight': 'bold' } : { 'font-weight': rowIndex === tableData.length - 1 ? 'bold' : 'normal' }">
          <strong *ngIf="i === data.centres.length - 1 || rowIndex === tableData.length - 1">{{ centre.count !== 0 ? centre.count : '-' }}</strong>
          <span *ngIf="i !== data.centres.length - 1 && rowIndex !== tableData.length - 1">{{ centre.count !== 0 ? centre.count : '-' }}</span>
        </td>
      </tr>
      </tbody>
    </table>
  </div>



</div>
